import React, { ReactNode } from "react";
import { StyleProp, View, ViewStyle } from "react-native";
import { IconButton } from "../icon-button";
import { useThemedStyle, StyleFunction } from "../../theme";

export function RemovableRow({
    children,
    onRemove,
    disabled,
    style,
    closePosition = "center",
}: {
    children: ReactNode;
    onRemove: () => void;
    disabled?: boolean;
    style?: StyleProp<ViewStyle>;
    closePosition?: "top" | "center";
}) {
    const styles = useThemedStyle(styleFunc);

    return (
        <View style={[styles.row, style]}>
            {children}
            {!disabled && (
                <IconButton
                    name="close"
                    onPress={onRemove}
                    size="normal"
                    style={[
                        styles.removeIcon,
                        closePosition === "top" ? styles.removeIconTop : null,
                    ]}
                />
            )}
        </View>
    );
}

const styleFunc: StyleFunction = theme => ({
    row: {
        flexDirection: "row",
    },
    removeIcon: {
        color: theme.colors.textDark,
        justifyContent: "center",

        // This matches the size of the icon, so the clickable area is that big.
        height: 34,
        width: 34,
    },
    removeIconTop: {
        justifyContent: "flex-start",
    },
});
